import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import {
  CheckCircleRounded as DoneIcon,
  CancelRounded as CancelledIcon,
} from "@mui/icons-material";
import { COLORS } from "../../../styles/uiConstants";
import useTerms from "../../../hooks/useTerms";

function formatDuration(ms) {
  if (ms == null) return "";
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  return `${h}sa ${m}dk`;
}

function formatTime(d) {
  if (!d) return "";
  return new Date(d).toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Başlık şeridinin altındaki ince durum şeridi (LockedByExaminationBanner
 * ile aynı dil): tamamlanan / iptal edilen muayene. Süren muayenede çizilmez.
 */
export function StatusStrip({ icon: Icon, tone, title, detail }) {
  return (
    <Box
      role="status"
      sx={{
        mx: { xs: 2, md: 4 },
        my: 1.5,
        px: 2,
        py: 1.25,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        borderRadius: 2,
        border: `1px solid ${alpha(tone, 0.25)}`,
        bgcolor: alpha(tone, 0.06),
        flexShrink: 0,
      }}
    >
      <Icon sx={{ fontSize: 20, color: tone }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: tone }}>
          {title}
        </Typography>
        {detail ? (
          <Typography sx={{ fontSize: "0.78rem", color: COLORS.slate600 }}>
            {detail}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}

export default function CompletionBanner({
  status,
  completedAt,
  cancelledAt,
  durationMs,
  cancelReason,
}) {
  const terms = useTerms();
  if (status === "completed") {
    return (
      <StatusStrip
        icon={DoneIcon}
        tone={COLORS.successDark}
        title={`${terms.exam} tamamlandı`}
        detail={`${formatTime(completedAt)} · Süre ${formatDuration(durationMs)}`}
      />
    );
  }

  if (status === "cancelled") {
    return (
      <StatusStrip
        icon={CancelledIcon}
        tone={COLORS.errorDark}
        title={`${terms.exam} iptal edildi`}
        detail={`${formatTime(cancelledAt)}${cancelReason ? ` · ${cancelReason}` : ""}`}
      />
    );
  }

  return null;
}
